import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import API_BASE_URL from "../../config";
import "./Credentials.css";

export default function Credentials() {
  const { t } = useTranslation();
  const [credentials, setCredentials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [expandedId, setExpandedId] = useState(null);

  const emptyForm = {
    label: "",
    snmp_community: "public",
    snmp_version: "v2c",
    ssh_username: "",
    ssh_password: "",
    telnet_username: "",
    telnet_password: "",
    notes: ""
  };

  const [formData, setFormData] = useState(emptyForm);
  useEffect(() => {
    fetchCredentials();
  }, []);

  const fetchCredentials = async () => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/info-manage/credentials`
      );

      const json = await res.json();
      if (json.success) {
        setCredentials(json.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editData
        ? `${API_BASE_URL}/info-manage/credentials/edit/${editData.id}`
        : `${API_BASE_URL}/info-manage/credentials/add`;

      const method = editData ? "PUT" : "POST";
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const result = await res.json();
      if (result.success) {
        setShowForm(false);
        setEditData(null);
        setFormData(emptyForm);
        fetchCredentials();
      } else {
        alert(result.error || "Something went wrong");
      }
    } catch (err) {
      alert("Error connecting to server");
    }
  };

  const handleEdit = (cred) => {
    setEditData(cred);
    setFormData({
      label: cred.label || "",
      snmp_community: cred.snmp_community || "public",
      snmp_version: cred.snmp_version || "v2c",
      ssh_username: cred.ssh_username || "",
      ssh_password: "",
      telnet_username: cred.telnet_username || "",
      telnet_password: "",
      notes: cred.notes || ""
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      const res = await fetch(
        `${API_BASE_URL}/info-manage/credentials/delete/${id}`,
        {
          method: "DELETE"
        }
      );

      const result = await res.json();
      if (result.success) {
        fetchCredentials();
      } else {
        alert(result.error || "Delete failed");
      }
    } catch (err) {
      alert("Error connecting to server");
    }
  };

  const openAddModal = () => {
    setEditData(null);
    setFormData(emptyForm);
    setShowForm(true);
  };

  const closeModal = () => {
    setShowForm(false);
    setEditData(null);
  };

  return (
    <div className="creds-container">
      <div className="creds-header-card">
        <div><h2>Credentials</h2><p> Manage Web,SSH,Telnet & SNMP Creds </p></div>
        <button
          className="creds-btn login"
          onClick={openAddModal}
        > + Add Credential
        </button>
      </div>

      {showForm && (
        <div className="creds-modal-overlay">
          <div className="creds-modal">
            <div className="creds-modal-header">
              <div><h3>{editData ? "Edit Credential" : "Add Credential"}</h3>
                <span>Configure credential details</span>
              </div>
              <button
                className="creds-modal-close"
                onClick={closeModal}
              > ✕
              </button>
            </div>

            <form
              onSubmit={handleSubmit}
              className="cpop-form"
            >
              <div className="cpop-input-group">
                <label>Label</label>
                <input
                  type="text"
                  name="label"
                  value={formData.label}
                  onChange={handleChange}
                  required
                  placeholder="Ex: Global SNMP"
                />
              </div>

              <div className="cpop-grid-row">
                <div className="cpop-input-group">
                  <label>SNMP Community</label>
                  <input
                    type="text"
                    name="snmp_community"
                    value={formData.snmp_community}
                    onChange={handleChange}
                    placeholder="public"
                  />
                </div>

                <div className="cpop-input-group">
                  <label>SNMP Version</label>
                  <select
                    name="snmp_version"
                    value={formData.snmp_version}
                    onChange={handleChange}
                  >
                    <option value="v1">v1</option>
                    <option value="v2c">v2c</option>
                    <option value="v3">v3</option>
                  </select>
                </div>
              </div>

              <div className="cpop-grid-row">
                <div className="cpop-input-group">
                  <label>SSH Username</label>
                  <input
                    type="text"
                    name="ssh_username"
                    value={formData.ssh_username}
                    onChange={handleChange}
                    placeholder="username"
                  />
                </div>

                <div className="cpop-input-group">
                  <label>SSH Password</label>
                  <input
                    type="password"
                    name="ssh_password"
                    value={formData.ssh_password}
                    onChange={handleChange}
                    placeholder={
                      editData
                        ? "Leave blank to keep existing"
                        : "password"
                    }
                  />
                </div>
              </div>

              <div className="cpop-grid-row">
                <div className="cpop-input-group">
                  <label>Telnet Username</label>
                  <input
                    type="text"
                    name="telnet_username"
                    value={formData.telnet_username}
                    onChange={handleChange}
                    placeholder="username"
                  />
                </div>

                <div className="cpop-input-group">
                  <label>Telnet Password</label>
                  <input
                    type="password"
                    name="telnet_password"
                    value={formData.telnet_password}
                    onChange={handleChange}
                    placeholder={
                      editData
                        ? "Leave blank to keep existing"
                        : "password"
                    }
                  />
                </div>
              </div>

              <div className="cpop-input-group">
                <label>Notes</label>
                <textarea
                  name="notes"
                  rows="4"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Optional notes..."
                />
              </div>

              <div className="cpop-button-group">
                <button
                  type="button"
                  className="cpop-btn-cancel"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="cpop-btn-submit"
                >
                  {editData ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {loading ? (
        <div className="creds-loading">
          Loading credentials...
        </div>
      ) : (
        <ul className="creds-list">
          {credentials.map((cred) => (
            <li
              key={cred.id}
              className="creds-item"
            >
              <div className="creds-item-main">

                <div className="creds-info">
                  <div className="creds-meta">
                    <strong className="creds-hostname">
                      {cred.label}
                    </strong>
                    <div className="creds-subinfo">
                      SNMP:
                      {" "}
                      {cred.snmp_community}
                      {" "}
                      ({cred.snmp_version})

                      {cred.ssh_username &&
                        ` | SSH: ${cred.ssh_username}`
                      }
                    </div>
                  </div>
                </div>
                <div className="creds-actions">
                  <button
                    className="creds-btn info"
                    onClick={() =>
                      setExpandedId(
                        expandedId === cred.id
                          ? null
                          : cred.id
                      )
                    }
                  >
                    {expandedId === cred.id
                      ? "Hide"
                      : "Details"}
                  </button>
                  <button
                    className="creds-btn edit"
                    onClick={() => handleEdit(cred)}
                  >
                    Edit
                  </button>
                  <button
                    className="creds-btn delete"
                    onClick={() =>
                      handleDelete(cred.id)
                    } > Delete
                  </button>
                </div>
              </div>

              {expandedId === cred.id && (
                <div className="creds-details-box">
                  <div className="creds-details-grid">
                    <div className="creds-detail-card">
                      <span>SNMP Community</span><strong> {cred.snmp_community} </strong></div>
                    <div className="creds-detail-card">
                      <span>SNMP Version</span><strong> {cred.snmp_version}</strong></div>
                    <div className="creds-detail-card">
                      <span>SSH Username</span><strong> {cred.ssh_username || "-"} </strong></div>
                    <div className="creds-detail-card">
                      <span>Telnet Username</span><strong> {cred.telnet_username || "-"} </strong></div>
                    <div className="creds-detail-card full">
                      <span>Notes</span><strong> {cred.notes || "-"} </strong></div>
                  </div>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}